export default "__VITE_PUBLIC_ASSET__74073b1f__"